import React from "react";
import TodayTrend from "../api/TodayTrend";
import MovieRow from "./MovieRow";

const trendFetcher = (_page, config) => TodayTrend(config);

const Trend = () => (
  <MovieRow title="Today's Trending" seeAllPath="/trend" fetcher={trendFetcher} />
);

export default Trend;
